<div class="expander group w-full transform rounded-xl bg-white px-2 py-4 shadow-lg transition-all duration-700 ease-in-out hover:-translate-y-1 hover:shadow-xl sm:p-4 md:p-6">
	<div class="flex w-full flex-row flex-wrap items-center">
		<div class="mb-2 flex w-full flex-row md:mb-0 md:w-2/5 lg:w-3/6">
			<div class="h-12 w-12 rounded-full bg-gray-400 md:h-16 md:w-16">
				<ngx-skeleton-loader count="1" appearance="circle"></ngx-skeleton-loader>
			</div>
			<div class="flex-1 pl-3">
				<div class="w-full">
					<ngx-skeleton-loader
						count="1"
						[theme]="{
							'border-radius': '5px',
							height: '16px',
							width: '25%',
							'background-color': '#efefef',
						}"
					></ngx-skeleton-loader>
				</div>
				<div class="w-full">
					<ngx-skeleton-loader
						count="1"
						[theme]="{
							'border-radius': '5px',
							height: '18px',
							width: '60%',
							'background-color': '#efefef',
						}"
					></ngx-skeleton-loader>
				</div>
				<div class="w-full">
					<ngx-skeleton-loader
						count="1"
						[theme]="{
							'border-radius': '5px',
							height: '10px',
							width: '10%',
							'background-color': '#efefef',
						}"
					></ngx-skeleton-loader>
				</div>
			</div>
		</div>
		<div class="mb-2 w-full md:mb-0 md:w-2/5 md:px-4 lg:w-2/6">
			<div class="w-full">
				<ngx-skeleton-loader
					count="1"
					[theme]="{
						'border-radius': '5px',
						height: '16px',
						width: '95%',
						'background-color': '#efefef',
					}"
				></ngx-skeleton-loader>
			</div>
			<div class="w-full">
				<ngx-skeleton-loader
					count="1"
					[theme]="{
						'border-radius': '5px',
						height: '16px',
						width: '95%',
						'background-color': '#efefef',
					}"
				></ngx-skeleton-loader>
			</div>
		</div>
		<div class="flex w-full flex-row flex-wrap items-center justify-end md:w-1/5 lg:w-1/6">
			<ngx-skeleton-loader
				count="1"
				[theme]="{
					'border-radius': '5px',
					height: '18px',
					width: '95%',
					'background-color': '#efefef',
				}"
			></ngx-skeleton-loader>
		</div>
	</div>
</div>
